<template>
    <div class="w-full">
        <!-- Title Section -->
        <div v-if="!showPopup" class="mb-5 self-stretch relative w-full flex items-center justify-center gap-2">
        <header class="absolute left-0 top-1/2 -translate-y-1/2">
            <a href="javascript:;" @click="back">
          <img src="@/assets/icons/arrow-left.svg" class="w-[25px]" />
        </a>
        </header>
            <div class="self-stretch flex flex-col text-center items-center gap-1">
                <div class="self-stretch text-center text-white text-2xl font-bold font-['Inter'] leading-[30px]">
                {{ $t('profile_change_password') }}
                </div>
            </div>
        </div>

        <form v-if="!showPopup" action="#" method="POST" @submit.prevent="formRequest">

            <div class="mb-4 max-[800px]:mb-[18px]">
                <label class="block text-white/90 text-base leading-[1.18rem] mb-[13px] pl-[10px]" for="#new_password">{{ $t('new_password') !== 'new_password' ? $t('new_password') : 'New password' }}</label>
                <div class="relative">
                    <input
                        :type="showNewPassword ? 'text' : 'password'"
                        required
                        :class="[
                            'w-full h-[44px] hover:bg-[#2A323B] bg-[#22282F] rounded-[10px] px-3 placeholder-white/70 outline-none caret-white',
                            errors.newPassword ? 'border border-red-500 text-red-500 focus:border-2 text-white' : 'border-2 border-transparent focus:border-[#6CBFFF] text-white'
                            ]"
                        name="new_password"
                        ref="new_password_input"
                        v-model="user.new_password"
                        placeholder=""
                        id="new_password"
                        autocomplete="new-password"
                    />
                        <button
                        type="button"
                        tabindex="-1"
                        @mousedown.prevent
                        @click="showNewPassword = !showNewPassword"
                        class="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer"
                    >
                        <img
                        :src="showNewPassword ? EyeIcon : EyeOffIcon"
                        class="w-5 h-5 opacity-70 hover:opacity-100"
                        alt="Toggle visibility"
                        />
                    </button>
                </div>
                <div v-if="errors.newPassword" class="text-red-500 text-sm mt-1 pl-[10px]">
                {{ errors.newPassword }}
                </div>
              </div>
          <div class="mb-4 max-[800px]:mb-[18px]">
            <label class="block text-white/90 text-base leading-[1.18rem] mb-[13px] pl-[10px]" for="#current_password">{{ $t('profile_retype_password') !== 'profile_retype_password' ? $t('profile_retype_password') : 'Confirm New password' }}</label>
            <div class="relative">
              <input
                  :type="showPassword ? 'text' : 'password'"
                  required
                  :class="[
                            'w-full h-[44px] hover:bg-[#2A323B] bg-[#22282F] rounded-[10px] px-3 placeholder-white/70 outline-none caret-white',
                            errors.retypePassword ? 'border border-red-500 text-red-500 focus:border-2 text-white' : 'border-2 border-transparent focus:border-[#6CBFFF] text-white'
                            ]"
                  name="current_password"
                  ref="current_password_input"
                  v-model="user.retypePassword"
                  placeholder=""
                  id="current_password"
                  autocomplete="new-password"
              />
              <button
                  type="button"
                  tabindex="-1"
                  @mousedown.prevent
                  @click="showPassword = !showPassword"
                  class="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer"
              >
                <img
                    :src="showPassword ? EyeIcon : EyeOffIcon"
                    class="w-5 h-5 opacity-70 hover:opacity-100"
                    alt="Toggle visibility"
                />
              </button>
            </div>
            <div v-if="errors.retypePassword" class="text-red-500 text-sm mt-1 pl-[10px]">
              {{ errors.retypePassword }}
            </div>
          </div>
            <div
            class=" mb-4 text-white text-sm bg-[#22282F] rounded-[10px] p-3 mt-2"
            >
            <p class="mb-1">{{ $t('signup_password_requirements') }}
            </p>
                <div class="flex flex-col">
                <span class="flex gap-2" :class="{ 'text-green-500': pwdCheck.length }">
                <span v-if="pwdCheck.length" class="w-3">&#10003;</span>
                <span v-else class="w-3">&#9679;</span>
                <span>{{ $t('signup_password_requirements_length') }}</span>
                </span>
                <span class="flex gap-2" :class="{ 'text-green-500': pwdCheck.uppercase }">
                <span v-if="pwdCheck.uppercase" class="w-3">&#10003;</span>
                <span v-else class="w-3">&#9679;</span>
                <span>{{ $t('signup_password_requirements_uppercase') }}</span>
                </span>
                <span class="flex gap-2" :class="{ 'text-green-500': pwdCheck.number }">
                    <span v-if="pwdCheck.number" class="w-3">&#10003;</span>
                <span v-else class="w-3">&#9679;</span>
                <span>{{ $t('signup_password_requirements_number') }}</span>
                </span>
            </div>
            </div>
                <div v-if="errors.general" class="text-red-500 text-sm mt-1 pl-[10px]">
                {{ errors.general }}
            </div>
                    <button type="submit" name="change_password_submit" id="change_password_submit" class="w-full h-[40px] px-[30px] bg-[#6CBFFF] hover:bg-opacity-30 rounded-xl shadow-[0px_5.01333px_5.01333px_rgba(0,0,0,0.25)] inline-flex justify-center items-center gap-2 overflow-hidden transition duration-160 cursor-pointer" value="Save">
                <div class="justify-start text-black text-base font-medium font-['Inter'] leading-normal">
                    {{ $t('common_save') }}
                </div>
            </button>
        </form>
            <div v-if="showPopup" >
                <div class=" text-white/90 text-base leading-[1.18rem] mb-5">Password was successfully changed!</div>
                <button @click="navigateToStart"  class="w-full h-[40px] px-[30px] bg-[#6CBFFF] hover:bg-opacity-30 rounded-xl shadow-[0px_5.01333px_5.01333px_rgba(0,0,0,0.25)] inline-flex justify-center items-center gap-2 overflow-hidden transition duration-160 cursor-pointer" value="OK">
                    <div class="justify-start text-black text-base font-medium font-['Inter'] leading-normal">
                        {{ $t('common_ok') }}
                    </div>
                </button>

            </div>
        </div>
</template>

<script>
import { mapState } from 'vuex';
import EyeIcon from '@/assets/icons/eye.svg';
import EyeOffIcon from '@/assets/icons/eye-off.svg';
import emitter from "@/services/emitter.service";

export default {
    name: 'ChangePasswordView',
    components: {
    },
    data() {
        return {
            user: {},
            errors: {
                newPassword: '',
                currentPassword: '',
                general: ''
            },
            showPopup: false,
            showPassword: false,
            showNewPassword: false,
            EyeIcon, 
            EyeOffIcon,
            pwdCheck: {
                length: false,
                uppercase: false,
                number: false,
            },
        }
    },
    computed: {
        ...mapState('auth', ['client_user', 'token', 'passwordChangeStatus'])
    },
    mounted() {
        this.$store.commit("auth/resetPasswordStatus");
        this.user.token = this.token;
    },
    watch: {
        passwordChangeStatus(newStatus) {
            console.log("passwordChangeStatus changed to: ", newStatus);
            if (newStatus === "success") {
                this.showPopup = true;
            }
        },
        'user.new_password': function(val) {
            this.pwdCheck.length = this.hasMinLength(val);
            this.pwdCheck.uppercase = this.hasUpperCase(val);
            this.pwdCheck.number = this.hasNumber(val);
        }
    },
    methods: {
        formRequest() {
            this.clearErrors();
            console.log("Payload before API call: ", this.user);
            if (this.validateNewPassword()) {
                this.$store.dispatch("auth/resetNewPassword", this.user).then(
                    () => {
                        this.$toast.success('profile_password_changed');
                        this.selfClose()
                    },
                    (error) => {
                        const errorKey = error.response?.data?.error || 'registration_failed';
                        const errorMessage = this.translateError(errorKey);
                        if (errorMessage.includes('Incorrect password')) {
                            this.errors.currentPassword = errorMessage;
                        }
                        else if (errorKey.includes('password')) {
                            this.errors.newPassword = errorMessage;
                        } else {
                            this.errors.general = errorMessage;
                        }
                    }
                );
            }
        },
        clearErrors() {
            this.errors = {
                newPassword: '',
                currentPassword: '',
                general: ''
            };
        },
        translateError(key) {
            let message = this.$t('error_unknown');
            
            if (this.$i18n.te(key)) {
                message = this.$t(key);
            } else if (this.$i18n.te('error_' + key)) {
                message = this.$t('error_' + key);
            } else {
                message += " (" + key + ")";
            }
            
            return message;
            },
        validateNewPassword() {
            if (!this.user.new_password || this.user.new_password.trim() === '') {
                this.errors.newPassword = 'Password is required';
                return false;
            }
            
            if (!this.hasMinLength(this.user.new_password)) {
                this.errors.newPassword = 'Password must be at least 8 characters long';
                return false;
            }

            if (!this.hasUpperCase(this.user.new_password)) {
                this.errors.newPassword = 'Password must have at least one upper-case character';
                return false;
            }

            if (!this.hasNumber(this.user.new_password)) {
                this.errors.newPassword = 'Password must contain at least one number';
                return false;
            }

            this.errors.newPassword = '';
            return true;
            },
        hasMinLength(password) {
            return password?.length >= 8 || false;
        },
        hasUpperCase(password) {
            return /[A-Z]/.test(password || "");
        },
        hasNumber(password) {
            return /\d/.test(password || "");
        },
        navigateToStart() {
            this.selfClose();
            this.$store.commit("auth/resetPasswordStatus");
            this.$store.dispatch("auth/logout");
        },
        back(){
            this.selfClose();
            emitter.emit("open-profile-popup");
        },
        selfClose(){
            this.$emitter.emit('modalClose');
        }
    }
}
</script>